import React, { useEffect } from 'react';
import { helpAuth } from '../../helpers/helpAuth';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";

import './css.css';

const Home = () => {

    useEffect(() => {
        let a = helpAuth();

		const hola = () => {
			if(a.auth) {
				if(a.perfil === '5') {
					window.location.href = "/filtro/na";
				} else {
					window.location.href = "/dashboard";
				}
			} else {
				return;
			}
		}
		
		hola();
    }, []);


    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="grid grid-nogutter surface-section text-800">
                        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center ">
                            <section>
                                <div className="text-primary mb-3 title-sup">Secretaría de Educación y Cultura del Estado de Sonora</div>
                                <span className="block mb-1 title">Entraga de uniformes escolares</span>
                                <p className="mt-0 mb-4 text-700 line-height-3 title-info"></p>

                                <Link to="/registro">
                                    <Button label="Registro" className="mr-3 p-button-rounded" />
                                </Link>
                                <Link to="/login">
                                    <Button label="Ingresar" className="p-button-rounded p-button-outlined"></Button>
                                </Link>
                            </section>
                        </div>
                        <div className="col-12 md:col-6 overflow-hidden">
                            <img src="images/blocks/hero/hero-4.png" alt="hero-5" className="md:ml-auto block md:h-full" style={{ clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)' }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;